import { FC, useEffect, useState } from "react";
import { useHistory } from "react-router";
import { Box, Button, Dialog, Grid, IconButton, Typography } from "@material-ui/core";
import useStyles from "../Styles/ProjectModalStyles";
import { MdClose } from "react-icons/md";
import Lottie from "lottie-react";

import TrophyAnimation from '../../assets/animations/Trophy.json';
import CryingAnimation from '../../assets/animations/CryingAnimation.json';
import FailedAnimation from '../../assets/animations/Failed.json';
import PendingAnimation from '../../assets/animations/Pending.json';

export type InvestState = 'investSuccess' | 'investChainError' | 'investFail' | 'investPendingConfirmation';


type InvestCardsProps = {
    open: boolean;
    setOpen: any;
    state: InvestState;
}

const InvestCards: FC<any> = ({ open, setOpen, state}: InvestCardsProps) => {

    const classes = useStyles();
    const history = useHistory();

    const [ selectedAnimation, setAnimation ] = useState<any>();
    const [investMessage, setMessage] = useState<string | null>();

    useEffect(() => {
        if (state === 'investSuccess') {
            setAnimation(TrophyAnimation);
            setMessage('You have successfully contributed to this deal! You can check your portfolio to see your investment.');
        } else if (state === 'investChainError') {
            setAnimation(FailedAnimation);
            setMessage('There was a smart contract error while trying to invest. Please try again.');
        } else if (state === 'investFail') {
            setAnimation(CryingAnimation);
            setMessage('Looks the deal has received the maximum amount of contributions. Please refresh the page to see the updated status.');
        } else if (state === 'investPendingConfirmation') {
            setAnimation(PendingAnimation);
            setMessage('Your contribution is being processed by our servers. Please wait a few minutes and check your portfolio to see your investment.');
        }
    }, [state])

    const handleClose = (event: React.SyntheticEvent<any, Event>, reason: string) => {
        if (reason === 'backdropClick') return;
        setOpen(false);
    }

    const handleFinish = (event: React.SyntheticEvent<any, Event>) => {
        history.push('/portfolio');
    }


    return (
        <>
            <Box component="section">
                <Dialog
                    open={open}
                    onClose={handleClose}
                    className={classes.modalpages}
                    aria-labelledby="contribution"
                    aria-describedby="contribution-result"
                    disableEscapeKeyDown={false}
                >
                    <Grid
                        container
                        style={{
                            padding: "20px",
                            display: "block"
                        }}
                        direction="column"
                    >
                        <Grid
                            item
                        >
                            <Grid
                                container
                                direction="row"
                                justifyContent="space-between"
                                alignItems="flex-start"
                            >
                                <Grid
                                    item
                                >
                                    <IconButton
                                        edge="end"
                                        color="inherit"
                                        aria-label="close"
                                        onClick={(event) => handleClose(event, 'buttonClick')}
                                    >
                                        <MdClose />
                                    </IconButton>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid 
                            item
                            lg={12}
                            style={{
                                display: "flex",
                                justifyContent: "center",
                            }}
                        >
                            <Lottie animationData={selectedAnimation} style={{
                                width: "180px",
                                height: "auto",
                            }} />
                        </Grid>
                        <Grid
                            item
                        >
                            <Grid 
                                container
                                justifyContent="center"
                                lg={12}
                            >
                                <Grid item lg={12}>
                                    <Typography variant="h3" className={classes.progressTitle}>
                                        {
                                            (state === 'investSuccess') 
                                            ?
                                                (
                                                    <>
                                                        Congratulations!
                                                    </>
                                                )
                                            :
                                                (
                                                    <>
                                                        Oops!
                                                    </>
                                                )
                                        }
                                    </Typography>
                                </Grid>
                                <Grid item lg={9}>
                                    <Typography variant="body1" className={classes.progressMessage}>
                                        {investMessage}
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid
                            item
                        >
                            <Grid 
                                container
                                justifyContent="center"
                                lg={12}
                                direction="row"
                                style={{
                                    marginTop: "20px",
                                }}
                                spacing={2}
                            >
                                {
                                    (state === 'investSuccess') 
                                    ?
                                        (
                                            <Grid item lg={10} xs={10} md={10} sm={10}>
                                                <Button variant="contained" color="primary" fullWidth onClick={(e) => handleFinish(e)}>
                                                    Check Porfolio
                                                </Button>
                                            </Grid>
                                        )
                                    :
                                        (
                                            <Grid item lg={10} xs={10} md={10} sm={10}>
                                                <Button variant="outlined" color="secondary" fullWidth onClick={(e) => handleClose(e, 'buttonClick')}>
                                                        Close
                                                </Button>
                                            </Grid>
                                        )
                                }
                            </Grid>
                        </Grid>
                    </Grid>
                </Dialog>
            </Box>
        </>
    )
}

export default InvestCards;